import { useSelector } from "react-redux";
import apiAction from "../ajax/service";
import {
  resetPageData,
  setDataByPage,
  setTotalData,
  setRentalInfo,
  setRentAgreements,
  setInvoiceInfo,
  clearRentInfo,
} from "../features/rentSlice";
import { loadAdjacentPages } from "./helpers/helpers";
import { saveActionResultsToState } from "../features/analyticsSlice";

const loadRentals = async (
  dispatch,
  page = 1,
  limit = 25,
  pageData = {},
  propograte = true,
  rentalFilters = {}
) => {
  if (pageData instanceof Set) {
    if (pageData.has(page)) return;
  } else {
    if (page in pageData) return;
  }

  var data = await apiAction("rents", { page, limit  , filters : { select:{
    id:true , name:true , images:true , type:true , description:true
  } , ...rentalFilters }}, "getAll",dispatch);

  if (propograte) {

    dispatch(setDataByPage(data.data));
    dispatch(setTotalData(data.totalRecords));
    // loadAdjacentPages(
    //   dispatch,
    //   page,
    //   limit,
    //   loadRentals,
    //   resetPageData,
    //   1,
    //   pageData,
    // );
  } else {
    dispatch(resetPageData({ action: "set", page, data: data.data }));
    dispatch(setTotalData(data.totalRecords));
  }
};


const loadRentalInfo = async (dispatch, id) => {
  // console.log(id);
  if (id == undefined) return;
  var data = await apiAction("rents", { id }, "fetchRelated",dispatch);

  var agreements = data.data["agreementItems"];
  delete data.data["agreementItems"];
  dispatch(setRentalInfo(data.data));
  dispatch(
    setRentAgreements({ page: 1, data: agreements, total: data["total"] }),
  );

  // for (let agreement of agreements) {
  //   dispatch(
  //     setInvoiceInfo({
  //       agreementId: agreement.id,
  //       data: agreement["invoices"],
  //       page: 1,
  //       total: agreement._count.invoices,
  //     }),
  //   );
  // }
};

const loadRentalAnalytics = async (dispatch, id)=>{
  if (!id) return
  var data = await apiAction("stats", { id:id}, "perrental",dispatch);
  dispatch(saveActionResultsToState({action : "perrental", id: id , result:data }))
}

export { loadRentals, loadRentalInfo,loadRentalAnalytics };
